import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";


function DiscountCreatedMessage(props) {
    window.setTimeout(function () {
        // Move to a new location 
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Uusi alennus lisätty</h2>
        </div>
    );
}

function AddDiscount(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        discountTime: '',
        discountRate: ''
    })
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    //Look at this closer


    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    // Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            discountTime: Number(userData.discountTime),
            discountRate: Number(userData.discountRate)
        }
        const dataToReducer = {
            ...userData,
            time: Number(userData.discountTime),
            discount: Number(userData.discountRate)
        }

        try {
            await axios.post(`${SERVER_URI}/add_discount_rate/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
            props.dispatch({ type: "ADD_DISCOUNT", data: { newDiscount: dataToReducer } })
            setShow(!show);
        } catch (e) {
            console.log("Error in adding driver", e)
        }
    }
    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Lisää aika ja alennusprosentti </h2>
                            <form className="discount_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="discountTime">Aika minuutteina:</label>
                                <input type="number" id="discountTime" name="discountTime" onChange={onChange} placeholder="Aika" min="1" max="5000000000" required></input>min<span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="discountRate">Alennusprosentti:</label>
                                <input type="number" id="discountRate" name="discountRate" placeholder="Prosentti" min="0" max="5000000000" onChange={onChange} required ></input>%<span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Lisää alennus" />
                            </form></div>
                    )}
                    {show && <DiscountCreatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default AddDiscount;